/*
* 系统枚举
* */
export enum SYSTEM_ENUM {
  OPS = 'SCM_OPS',
}
/*
* SSO url 返回授权code 字段名称
* */
export const SSO_AUTHORIZATION_CODE = 'code';
